import { usePostMutation } from "../../../hooks/useClientPortalQuery";

import { useClientPortalConfigContext } from "../../../context/ClientPortalConfig.ctx";
import { AxiosError } from "axios";

interface RevokeCardConsentModel {
    practitionerId?: number;
    clientId?: number;
}

export function useRevokeCardConsent(clientId?: number) {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const { mutateAsync } = usePostMutation<void, AxiosError, RevokeCardConsentModel>({
        url: `/api/v1/${clientPortalGuid}/Stripe/RevokeCardConsent`,
    });

    return {
        revokeCardConsent: (practitionerId?: number) => mutateAsync({ practitionerId, clientId }),
    };
}
